module.exports = __webpack_public_path__ + "img/20220502_104515.a48ece2c.jpg";